/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Utils
import { cloneDeep, extend, isFunction } from 'lodash';

// Components
import AttendanceCriteria from 'ui/components/event-settings/AttendanceCriteria.vue';
import Labelling from 'ui/components/event-settings/Labelling.vue';
import LegalOptions from 'ui/components/event-settings/LegalOptions.vue';
import Logistics from 'ui/components/event-settings/Logistics.vue';
import NavEditor from 'shared/ui/components/editors/NavEditor.vue';
import RegistryEditor from 'shared/ui/components/editors/RegistryEditor.vue';
import SupportOptions from 'ui/components/event-settings/SupportOptions.vue';
import UnsavedChanges from 'shared/ui/modals/UnsavedChanges.vue';
import WorkspaceInfo from 'ui/components/event-settings/WorkspaceInfo.vue';

const __vue_script__ = {
    name: 'EventSettings',

    components: {
        AttendanceCriteria,
        Labelling,
        LegalOptions,
        Logistics,
        NavEditor,
        RegistryEditor,
        SupportOptions,
        WorkspaceInfo
    },

    props: {
        params: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            event: null,
            save: 0,
            innerValue: {},
            canChangeSettings: false,
            currentComponent: 'WorkspaceInfo',
            subpages: ['WorkspaceInfo', 'Logistics', 'Labelling', 'LegalOptions'],
            regSettings: [],
            navEditors: [],
            submitting: false,
            regPath: null,
            changeReason: null,
            navEditor: null,
            navConfig: null
        };
    },

    computed: {
        isRegistrySettings() {
            return this.regSettings.includes(this.regPath);
        },

        isNavIds() {
            return this.navEditors.includes(this.navEditor);
        }
    },

    async created() {
        await this.loadEvent();

        if (this.event?.attendance_tracking_enabled) {
            this.subpages.push('AttendanceCriteria');
        }

        if (this.$services.user.isBetaTester()) {
            const dateReg = await this.$services.settings.getRegistrySettings(this.params.event._id, 'date');
            if (dateReg) {
                this.regSettings.push('date');
            }

            const notificationsReg = await this.$services.settings.getRegistrySettings(this.params.event._id, 'notifications');
            if (notificationsReg) {
                this.regSettings.push('notifications');
            }
        }

        const navEditors = this.params.currentController.routeOptions?.navEditors;
        if (navEditors) {
            this.navEditors.push(...Object.keys(navEditors));
        }

        this.subpages.push(...this.regSettings, ...this.navEditors);

        const canAccessSupport = this.$services.user.matchesRoles(
            { globalRole: 'superadmin' },
            { globalRole: 'spotme_support' }
        );

        if (canAccessSupport) {
            this.subpages.push('SupportOptions');
        }
    },

    mounted() {
        if (isFunction(window.BSTG.hotkeys?.bind)) {
            window.BSTG.hotkeys.bind('cmd + i, ctrl + i', this.openEventDocument.bind(this, false), 'Opens the event doc in the document editor');
            window.BSTG.hotkeys.bind('cmd + shift + i, ctrl + shift + i', this.openEventDocument.bind(this, true), 'Opens the event doc in a new window in the document editor');
        }
    },

    methods: {
        async loadEvent() {
            try {
                this.changeReason = null;
                this.event = await this.$services.event.getEvent(this.params.event._id, this.user);
                this.canChangeSettings = this.$services.user.hasPermission('node_crud_realms.modify_event_doc', { event_id: this.event._id });
            } catch (error) {
                console.error('[EventSettings] Could not load event data', error);
                this.$services.crashReporting.captureException(error);
            }
        },

        goTo(subpage, bypass = false) {
            if (this.$refs.subpageForm?.isFormDirty() && !bypass) {
                this.$modal.show(UnsavedChanges, {
                    action: () => this.goTo(subpage, true)
                }, { height: 'auto' });
                return;
            }

            this.regPath = null;
            this.navEditor = null;

            if (this.regSettings.includes(subpage)) {
                this.currentComponent = 'RegistryEditor';
                this.regPath = subpage;
            } else if (this.navEditors.includes(subpage)) {
                this.currentComponent = 'NavEditor';
                this.navEditor = subpage;
                this.navConfig = this.params.currentController.routeOptions?.navEditors[this.navEditor];
            } else {
                this.currentComponent = subpage;
            }
        },

        submit() {
            this.save = Date.now();
        },

        async saveChanges(newData) {
            try {
                if (this.submitting) {
                    return;
                }

                this.submitting = true;

                const orginalEvent = cloneDeep(this.event);
                const modifiedEvent = extend(orginalEvent, newData);

                console.debug('[EventSettings] New data received', newData, modifiedEvent);

                await this.$services.event.saveEvent(modifiedEvent, this.changeReason);

                this.$notify({
                    group: 'flashes',
                    text: this.$t('general_settings.messages.save_success').toString(),
                    type: 'success',
                    duration: 5000
                });

                await this.loadEvent();
                this.$refs.subpageForm.resetFormValidation();

            } catch (error) {
                console.error('[EventSettings] Could not save settings', newData, error);
                this.$services.crashReporting.captureException(error);

                this.$notify({
                    group: 'flashes',
                    title: this.$t('general.error_occurred'),
                    text: this.$t('general_settings.messages.save_failed').toString(),
                    type: 'error',
                    duration: 10000
                });

            } finally {
                this.submitting = false;
            }
        },

        /**
         * Handler for opening a document in the document editor
         *
         * @param {boolean} newWindow open in new window
         */
        openEventDocument(newWindow) {
            const { controllers } = this.$services.blueprint.getModuleByName('document-editor');
            const route = controllers['document-editor'].route;

            const document = this.params.event._id;
            if (!document) {
                return;
            }

            if (newWindow) {
                console.info('[EventSettings] Opening in a new window');
                const path = route.replace(':eventId', this.event._id);
                this.$services.router.openNewWindow(`${path}?document=${document}`);
            } else {
                console.info('[EventSettings] Opening event document in the document editor');
                this.$router.push(route, { eventId: this.event._id }, { document });
            }
        }
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.event)?_c('div',{staticClass:"event-settings subpage"},[_c('h1',[_vm._v(_vm._s(_vm.$t('general_settings.titles.event_settings')))]),_c('div',{staticClass:"content"},[_c('div',{staticClass:"nav-list-wrapper"},[_c('div',{staticClass:"repeated-item-list-container"},[_c('ul',{staticClass:"nav nav-list"},_vm._l((_vm.subpages),function(subpage){return _c('li',{key:subpage,class:{ active: [_vm.currentComponent, _vm.regPath, _vm.navEditor].includes(subpage) }},[_c('a',{staticClass:"has-action",on:{"click":function($event){return _vm.goTo(subpage)}}},[_vm._v(_vm._s(_vm.$t(("general_settings.menu." + (_vm.$utils.strings.toSnakeCase(subpage))))))])])}),0)])]),_c('div',{staticClass:"view-wrapper"},[_c(_vm.currentComponent,{key:_vm.currentComponent,ref:"subpageForm",tag:"component",attrs:{"save-spy":_vm.save,"event":_vm.event,"path":_vm.regPath,"nav-config":_vm.navConfig,"user":_vm.params.user},on:{"reason":function($event){_vm.changeReason = $event},"save":_vm.saveChanges},scopedSlots:_vm._u([(_vm.regPath)?{key:"title",fn:function(ref){return [_c('h3',[_vm._v(_vm._s(_vm.$t(("general_settings.menu." + (_vm.$utils.strings.toSnakeCase(_vm.regPath))))))])]}}:null],null,true)})],1)]),(_vm.canChangeSettings && !_vm.isRegistrySettings && !_vm.isNavIds)?_c('secondary-toolbar',[_c('button',{staticClass:"btn btn-primary",attrs:{"disabled":_vm.submitting},on:{"click":_vm.submit}},[_vm._v(_vm._s(_vm.$t('general.save')))])]):_vm._e()],1):_vm._e()}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "EventSettings.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__